import { PayloadAction, createAction, createReducer } from "@reduxjs/toolkit";

import { STORES } from "store/types";

import { AutomatedCollectionTab } from "./types";

export interface CollectionStatusState {
  automatedCollectionTab: AutomatedCollectionTab;
  isUtilityConnectionsVisible: boolean;
  entityFilter: string[];
  utilityProviderFilter: string[];
  activityFilter: string[];
}

// define action types
export const initialize = createAction(`${STORES.collectionStatus}/initialize`);

export const setAutomatedCollectionTab = createAction<AutomatedCollectionTab>(
  `${STORES.collectionStatus}/setAutomatedCollectionTab`
);

export const setIsUtilityConnectionsVisible = createAction<boolean>(
  `${STORES.collectionStatus}/setIsUtilityConnectionsVisible`
);

export const setEntityFilter = createAction<string[]>(
  `${STORES.collectionStatus}/setEntityFilter`
);

export const setUtilityProviderFilter = createAction<string[]>(
  `${STORES.collectionStatus}/setUtilityProviderFilter`
);

export const setActivityFilter = createAction<string[]>(
  `${STORES.collectionStatus}/setActivityFilter`
);
// create reducer
const collectionStatusReducer = createReducer<CollectionStatusState>(
  {
    automatedCollectionTab: AutomatedCollectionTab.INTEGRATIONS,
    isUtilityConnectionsVisible: false,
    entityFilter: [],
    utilityProviderFilter: [],
    activityFilter: [],
  },
  (builder) => {
    builder.addCase(initialize, (state) => initializeState(state));

    builder.addCase(
      setAutomatedCollectionTab,
      (state, action: PayloadAction<AutomatedCollectionTab>) => {
        state.automatedCollectionTab = action.payload;
      }
    );

    builder.addCase(
      setIsUtilityConnectionsVisible,
      (state, action: PayloadAction<boolean>) => {
        state.isUtilityConnectionsVisible = action.payload;
        if (!action.payload) {
          state.automatedCollectionTab = AutomatedCollectionTab.INTEGRATIONS;
        }
      }
    );

    builder.addCase(
      setEntityFilter,
      (state, action: PayloadAction<string[]>) => {
        state.entityFilter = action.payload;
      }
    );

    builder.addCase(
      setUtilityProviderFilter,
      (state, action: PayloadAction<string[]>) => {
        state.utilityProviderFilter = action.payload;
      }
    );

    builder.addCase(
      setActivityFilter,
      (state, action: PayloadAction<string[]>) => {
        state.activityFilter = action.payload;
      }
    );
  }
);

const initializeState = (state: CollectionStatusState) => {
  state.automatedCollectionTab = AutomatedCollectionTab.INTEGRATIONS;
};

export default collectionStatusReducer;
